import { InputIconWrapper, Search } from '@library/components/inputs';
import type {
  MemberEntriesFilterType,
  MemberEntriesFilterValue
} from '@library/types/members';
import { useCallback, useState } from 'react';
import { cn } from '@library/component-utils/cn';

export interface MemberEntriesFilterProps {
  className?: string;
  disabled?: boolean;
  iconClassName?: string;
  onValueChange: (value: MemberEntriesFilterValue) => void;
  placeholder: string;
  searchClassName?: string;
  value: string;
}

export const MemberEntriesFilter = ({
  className = '',
  disabled = false,
  iconClassName = '',
  onValueChange,
  placeholder,
  searchClassName = '',
  value
}: MemberEntriesFilterProps) => {
  const [inputIcon, setInputIcon] = useState('=');

  const handleChangeInputIcon = useCallback(() => {
    if (inputIcon === '=') {
      setInputIcon('>');
    } else if (inputIcon === '>') {
      setInputIcon('<');
    } else {
      setInputIcon('=');
    }
  }, [inputIcon]);

  const handleValueChange = useCallback(
    (newValue: string) => {
      let iconType: MemberEntriesFilterType;
      if (inputIcon === '=') {
        iconType = 'eq';
      } else if (inputIcon === '>') {
        iconType = 'gt';
      } else {
        iconType = 'lt';
      }
      onValueChange({ type: iconType, value: newValue });
    },
    [inputIcon, onValueChange]
  );

  return (
    <div className={cn('flex flex-col text-sm', className)}>
      <InputIconWrapper
        className={cn(
          'border-soFresh-140 flex h-11 w-full min-w-min rounded-md border py-1.5 text-sm sm:leading-6',
          disabled ? 'bg-soFresh-130' : 'bg-soFresh-110'
        )}
        hoverEnabled
        icon={inputIcon}
        iconClassName={cn('top-[20.5%]', iconClassName)}
        onIconClick={handleChangeInputIcon}
      >
        <Search
          className={cn(
            'text-soClean-100 placeholder:text-soClean-180 w-full rounded-md border-0 bg-transparent py-1.5 pl-[42px] text-sm hover:ring-0 focus:ring-0 sm:leading-6',
            searchClassName
          )}
          data-testid="member-entries-filter"
          disabled={disabled}
          id="MemberEntriesFilter"
          onValueChange={handleValueChange}
          placeholder={placeholder}
          value={value}
        />
      </InputIconWrapper>
    </div>
  );
};
